export const ACTIVE = 'ACTIVE';
export const TRANSFERRED = 'TRANSFERRED';
export const DEBT_COLLECTION = 'DEBT_COLLECTION';
export const DEBT_COLLECTION_COMPLETED = 'DEBT_COLLECTION_COMPLETED';
export const DEPRECIATED = 'DEPRECIATED';
export const REMINDED = 'REMINDED';
export const DUE_NOT_REMINDED = 'DUE_NOT_REMINDED';
export const FULLY_CREDITED = 'FULLY_CREDITED';
